import { notifyPaymentIntent } from './notifier';
import { getEventDataForSdkEvents } from './eventDataBuilder';
import type { ICheckoutContext } from '@/types/context';
import { trackPayButtonClicked } from './checkoutMixpanelTracking';

export const trackAndNotifyPaymentClick = (context: ICheckoutContext, paymentMethodName?: string) => {
  const selectedPaymentMethodName = paymentMethodName ?? context.paymentMethodSelected;

  trackPayButtonClicked(context, selectedPaymentMethodName);
  notifyPaymentIntent(getEventDataForSdkEvents(context, { paymentMethodName: selectedPaymentMethodName }));
};
